import React from "react";
import "./TableComponent.scss";
import { Table } from "antd";

const TableComponent = ({
  columns,
  data,
  pagination,
  onTableChange,
  // onEyeClick,
  // level,
}) => {
  // const modifiedColumns = [
  //   ...columns,

  // ];

  return (
    <div className="table-component">
      <Table
        columns={columns}
        dataSource={data}
        pagination={pagination}
        onChange={onTableChange}
        rowKey={(record) => record.id}
      />
    </div>
  );
};

export default TableComponent;
